import { Fragment } from "react"

import { define, prop } from "@/components/builder/utils"

import BasePreview from "../../base"

function MidpathTCPAErrorFeedbackPreview(props) {
  return <BasePreview {...props}>
    <span className='invalid-feedback tcpa-required-feedback'>
      Validation message to display when the field is required and the user does not select an option.
    </span>
  </BasePreview>
}

export default define('tcpa-required-feedback', MidpathTCPAErrorFeedbackPreview, Fragment)
  .shared(prop.share('MidpathTCPAErrorFeedback', 'tcpa-required-feedback'), { prefix: false })
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()
